/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Templates_Deactivate_Default_BlockedInputs */

const cs_templates_deactivate_default_blocked = /** @type {(inputs: Templates_Deactivate_Default_BlockedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nelze deaktivovat výchozí šablonu. Nejdřív nastavte jinou jako výchozí, nebo výchozí zrušte.`)
};

const en_templates_deactivate_default_blocked = /** @type {(inputs: Templates_Deactivate_Default_BlockedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cannot deactivate the default template. Set another default first, or clear default.`)
};

/**
* | output |
* | --- |
* | "Cannot deactivate the default template. Set another default first, or clear default." |
*
* @param {Templates_Deactivate_Default_BlockedInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const templates_deactivate_default_blocked = /** @type {((inputs?: Templates_Deactivate_Default_BlockedInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Templates_Deactivate_Default_BlockedInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_templates_deactivate_default_blocked(inputs)
	return cs_templates_deactivate_default_blocked(inputs)
});